import React from 'react';
import { usePageWidth } from '../../../navigation/pageWidth';

/**
 * The page area of the Forge, Eval, Archon and Lurker shells. It carries the matched page's
 * width, which forge-theme.css reads to cap chart dashboards, short lists and forms.
 */
export const ShellMain: React.FC<{
  isResizing: boolean;
  marginLeft: number;
  children: React.ReactNode;
}> = ({ isResizing, marginLeft, children }) => {
  const pageWidth = usePageWidth();
  return (
    <main
      className={`forge-main-content ${isResizing ? 'sidebar-resizing' : ''}`}
      data-page-width={pageWidth}
      style={{ marginLeft }}
    >
      {children}
    </main>
  );
};
